import history from "@history.js";
import {
  SET_USER_DATA,
  USER_DATA_CONSTANT,
  REMOVE_USER_DATA,
  USER_LOGGED_OUT,
  ADD_SITE_IDS,
  FILTER_STATUS_ADD,
  SET_PERIOD_MONTH_DATE,
} from "app/_constants/Redux/userData.constant";
import jwtAuthService from "../../services/jwtAuthService";
import { getDateByMonthPeriod } from "app/_helpers/helper";
import configureStore from "app/redux/Store";
let { store } = configureStore();

// export const SET_USER_DATA = "USER_SET_DATA";

export function setUserData(user) {
  return (dispatch) => {
    dispatch({
      type: SET_USER_DATA,
      data: user,
    });
  };
}

export function setPeriodDate(period) {
  let startDate = period !== "inception" ? getDateByMonthPeriod(+period) : "";
  return (dispatch) => {
    dispatch({
      type: SET_PERIOD_MONTH_DATE,
      data: { startDate, period: period },
    });
  };
}

export function logoutUser() {
  return (dispatch) => {
    jwtAuthService.logout();

    const url = window.location.href.includes("mobile")
      ? "/mobile/auth/sign-in"
      : "/session/signin";

    history.push({
      pathname: url,
    });

    dispatch({
      type: USER_LOGGED_OUT,
    });

    dispatch({
      type: ADD_SITE_IDS,
      data: null,
    });
    dispatch({
      type: FILTER_STATUS_ADD,
      data: {
        myVFLSearch: "",
        medicalSearch: "",
        assignSearch: "",
        manageMeetingSearch: "",
        manageVFLSearch: "",
        manageIncidentSearch: "",
        myIncidentSearch: "",
        myOHSEReviewSearch: "",
        viewOHSEReviewSearch: "",
        manageCapaSearch: "",
        trainingStatusSearch: "",
        viewMedicalDataSearch: "",
        viewTaskSearch: "",
        viewVFLSearch: "",
        capaOwnerDesktopSearch: "",
        manageCAPADesktopSearch: "",
        myApprovalHistoryOHSEDesktop: "",
        myOHSEReviewDesktopSearch: "",
        viewOHSEDesktopSearch: "",
        myMeetingsTaskDesktopSearch: "",
        OHSEReviewTaskDesktopSearch: "",
        formADesktopSearch: "",
        viewIncidentsIMDesktopSearch: "",
        myApprovalActionIMSDesktopSearch: "",
        myApprovalHistoryIMDesktopSearch: "",
        myIncidentsImDesktopSearch: "",
        medicalExamDueDesktopSearch: "",
        myApprovalActionMedicalDesktopSearch: "",
        MyApprovalHistoryMedicalDesktopSearch: "",
        ViewMedicalDataDesktopSearch: "",
        scheduleTrainingDesktopSearch: "",
        trainingBatchHistoryTM1DesktopSearch: "",
        trainingBatchesDesktopSearch: "",
        myApprovalActionDesktopSearch: "",
        myApprovalHistoryDesktopSearch: "",
        trainingStatusDesktopSearch: "",
        viewVFLDesktopSearch: "",
        myApprovalActionVFLDesktopSearch: "",
        myApprovalHistoryVFLDesktopSearch: "",
        myVFLDesktopSearch: "",
        companyDesktopSearch: "",
        contractorDesktopSearch: "",
        contractorStaffDesktopSearch: "",
        employeeDesktopSearch: "",
        roleDesktopSearch: "",
        userRegistrationDesktopSearch: "",
        ticketHistoryDesktopSearch: "",
        allTrainingDesktopSearch: "",
      },
    });

    dispatch({
      type: USER_DATA_CONSTANT.TOGGLE_COLUMN,
      data: {
        userRegistration: [],
        scheduleTraining: [],
        capaOwner: [],
        contractor: [],
        contractorStaff: [],
        employee: [],
        trainingStatus: [],
        trainingBatches: [],
        myApprovalAction: [],
        myApprovalHistory: [],
        myApprovalHistoryOHSE: [],
        myOHSEReview: [],
        OHSEReviewTask: [],
        myMeetingsTask: [],
        myApprovalHistoryIM: [],
        manageCAPA: [],
        myVFL: [],
        viewVFL: [],
        medicalExamDue: [],
        myApprovalActionMedical: [],
        MyApprovalHistoryMedical: [],
        ViewMedicalData: [],
        formA: [],
        viewIncidentsIM: [],
        myApprovalActionIM: [],
        myApprovalActionOHSE: [],
        viewOHSE: [],
        myApprovalActionVFL: [],
        myApprovalHistoryVFL: [],
        myIncidentsIm: [],
        role: [],
        company: [],
        trainingBatchHistoryTM1: [],
        logInHistoryDesktopSearch: [],
        blockIpDesktopSearch: [],
        allTraining: [],
      },
    });
    window.location.reload();
  };
}
